/* English dictionary: common namespace (fixed strings reused across screens). See src/i18n/README.md. */

import type { TextSpec } from '../text';

const common = {
  'common.back': [ 'Back  (ESC)' ],
  'common.backPlain': [ 'Back' ],
  'common.settings': [ 'Settings' ],
  'common.credit': [ 'Credits' ],
  'common.changelog': [ 'Changelog' ],
  'common.close': [ 'Close' ],
  'common.netplay': [ 'Netplay' ],
  'common.room': [ 'Room' ],
  'common.createRoom': [ 'Create Room' ],
  'common.identity': [ 'Identity' ],
  'common.nickname': [ 'Nickname' ],
  'common.host': [ 'Host' ],
  'common.endTurn': [ 'End Turn' ],
  'common.gameOver': [ 'Game Over' ],
  'common.rulesAndDeck': [ 'Rules and Deck' ],
  'common.resetDefaults': [ 'Restore defaults' ],
  'common.unknownReason': [ 'unknown reason' ],
  'common.problemSeparator': [ '; ' ],
} as const;

// Static check (kept outside the object literal to avoid TextKey circular inference).
common satisfies Record<string, TextSpec>;
export default common;
